<template>
  <div>
    <h3 class="font-display text-sm font-bold uppercase tracking-wider text-ink">
      {{ $t('components.dashboard_sidebar.following') }}
    </h3>
    <p class="mt-1 text-base leading-snug text-muted">
      {{ $t('components.dashboard_sidebar.following_hint') }}
    </p>

    <ul
      v-if="user.followed_newsrooms.length"
      v-loading="isLoading"
      class="mt-3 flex flex-col gap-1"
    >
      <li
        v-for="newsroom in user.followed_newsrooms"
        :key="newsroom.id"
        class="flex items-center gap-3 rounded-lg px-2 py-1.5 hover:bg-row-hover"
      >
        <round-avatar
          :main-color="newsroom.main_color"
          :src="newsroom.logo.cropped"
          :acronym-fallback="newsroom.name"
          size="small"
        />
        <span class="min-w-0 flex-1 truncate font-display text-sm font-semibold text-ink">
          {{ newsroom.name }}
        </span>
        <button
          type="button"
          role="switch"
          aria-checked="true"
          :title="$t('components.dashboard_sidebar.unfollow')"
          :aria-label="$t('components.dashboard_sidebar.unfollow')"
          class="relative h-5 w-9 shrink-0 cursor-pointer rounded-full border-none bg-ink transition-colors hover:opacity-80"
          @click="unfollow(newsroom)"
        >
          <span class="absolute right-0.5 top-0.5 h-4 w-4 rounded-full bg-white" />
        </button>
      </li>
    </ul>

    <p v-else class="mt-3 text-base leading-snug text-muted-soft">
      {{ $t('components.dashboard_sidebar.to_follow_company') }}
    </p>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'dashboardUser'
    })
  },
  methods: {
    ...mapActions([
      'fetchCurrentUser',
      'fetchDashboardUser'
    ]),
    async unfollow (newsroom) {
      try {
        await this.$confirm(this.$t('components.dashboard_sidebar.confirm_unfollow', { name: newsroom.name }))
        this.isLoading = true
        await this.$api.post(`newsrooms/${newsroom.id}/unfollow`)
        await Promise.all([this.fetchCurrentUser(), this.fetchDashboardUser()])
        this.isLoading = false
      } catch (err) {
        this.isLoading = false
        if (err === 'cancel' || err === 'close') return
        this.$displayRequestError(err)
      }
    }
  }
}
</script>
